import { blend, clamp } from './interpolate';

const scoreDisputes = (ratio, benchmark) => {
  const half = benchmark * 0.5;
  if (ratio <= half) return 95;
  if (ratio <= benchmark) return 95 - ((ratio - half) / half) * (95 - 75);
  if (ratio <= benchmark * 2) return 75 - ((ratio - benchmark) / benchmark) * (75 - 45);
  return clamp(45 - (ratio - benchmark * 2) * 500, 20, 45);
};

const scoreResolution = (days) => {
  if (days <= 7) return 95;
  if (days <= 21) return 95 - ((days - 7) / 14) * (95 - 70);
  if (days <= 45) return 70 - ((days - 21) / 24) * (70 - 40);
  return clamp(40 - (days - 45) * 0.5, 20, 40);
};

const scoreLitigation = (count) => {
  if (count === 0) return 100;
  if (count <= 1) return 75;
  if (count <= 3) return 50;
  return clamp(50 - (count - 3) * 10, 15, 50);
};

export const scoreD7 = (inputs) => {
  const disputes = scoreDisputes(inputs.creditNoteRatio, inputs.sectorDisputeRate);
  const resolution = scoreResolution(inputs.avgDisputeResolutionDays);
  const litigation = scoreLitigation(inputs.litigatedDisputes);

  const score = blend([
    { score: disputes, weight: 0.5 },
    { score: resolution, weight: 0.3 },
    { score: litigation, weight: 0.2 },
  ]);

  return { score, subScores: { disputes, resolution, litigation } };
};
